import React from 'react';
import { Icon } from '@monorepo/icons';
import useUser from '../../hooks/useUser';
import styles from './index.module.css';

const LinkChat: FC = () => {
  const { data } = useUser();
  const chatHost = import.meta.env.VITE_CHAT_HOST || `${window.location.origin}/v0/ui/#`;
  return (
    <a
      href={`${chatHost}${data?.id}`}
      target="_blank"
      rel="noreferrer"
      className={styles.link}
    >
      <Icon name="chat_messages" />
    </a>
  );
};

export default LinkChat;
